import React, { useState } from "react"
import VizSensor from "react-visibility-sensor"
import classnames from "classnames"

const BlueZone = () => {
  const [isVisible, setVisibility] = useState(false)
  let baseClass = classnames(
    "grid",
    "grid-cols-12",
    { "opacity-0": !isVisible },
    { "text-slide-in": isVisible }
  )

  return (
    <section id="blue" className="h-full blue-zone bg-gray">
      <VizSensor
        onChange={setVisibility}
        active={!isVisible}
        partialVisibility={true}
      >
        <div className={baseClass}>
          <div className="col-span-12 p-10 md:p-20 lg:py-20 lg:px-0 lg:col-start-3 lg:col-span-8">
            <h2 className="font-medium text-gray-800 text-left text-4xl lg:text-4xl">
              ¿Por qué Alex?
            </h2>
            <h4 className="font-normal tracking-wide leading-normal text-xl">
              Con Alex no tienes que ser un experto para contratar un seguro de
              vida, ya que hemos eliminado todos los pasos innecesarios, que
              hacen que el proceso de contratar un seguro sea complicado y
              tedioso.
            </h4>
            <h4 className="font-normal tracking-wide leading-normal text-xl">
              Nuestro proceso de compra es tan simple como, rellenar 5 datos
              básicos sobre ti, escoger cual de las 3 opciones de póliza se
              ajusta mejor a tus necesidades y pagar con tarjeta de crédito o
              débito.
            </h4>
          </div>
        </div>
      </VizSensor>
    </section>
  )
}

export default BlueZone
